import { SearchInput } from '../shared';
import { SortOrder, CustomerAddressSortType, CustomerAddressType } from '../enums';

export class GetCustomerAddressesInput extends SearchInput<CustomerAddressSortType> {
    public districtId?: number | null;
    public provinceId?: number | null;
    public countryId?: number | null;
    public customerId?: number | null;
    public customerAddressType?: CustomerAddressType | null;

    constructor() {
        super(CustomerAddressSortType.CustomerName);
        this.districtId = null;
        this.provinceId = null;
        this.countryId = null;
        this.customerId = null;
        this.customerAddressType = null;
        this.sortOrder = SortOrder.Ascending;
    }
}